export type OrcamentoStatus = 'ORCAMENTO' | 'LEAD' | 'OS';
export type LeadCanal = 'WHATSAPP' | 'EMAIL' | 'LIGACAO';
export type WorkflowStatus = 'EM_ANDAMENTO' | 'ATRASADO' | 'CONCLUIDO';
export type ComunicacaoCanal = 'WHATSAPP' | 'EMAIL';
export type ComunicacaoStatusEnvio = 'ENVIADO' | 'FALHA' | 'PENDENTE';
export type HistoricoTipo = 'MUDANCA_ETAPA' | 'COMENTARIO' | 'ANEXO' | 'SISTEMA';
export type LeadStatus = 'ABERTO' | 'FECHADO';
export type OrcamentoAtendimentoStatus =
  | 'Aberto'
  | 'Aguardando retorno'
  | 'Efetuar Contato'
  | 'Perdido'
  | 'Ganho';
export type OrcamentoFase = 'ORCAMENTO' | 'OS' | 'EXECUCAO' | 'CONCLUIDO' | 'CANCELADO';
export type WorkflowFase = 'OS' | 'EXECUCAO' | 'CONCLUIDO' | 'CANCELADO';
export type AtendimentoPrioridade = 'BAIXA' | 'MEDIA' | 'ALTA';

export enum WorkflowEtapaTipo {
  ABERTURA_OS = 'ABERTURA_OS',
  COMPRA_PECAS = 'COMPRA_PECAS',
  PROGRAMACAO_REPARO = 'PROGRAMACAO_REPARO',
  DESMONTAGEM = 'DESMONTAGEM',
  ANALISE_COMPLEMENTO = 'ANALISE_COMPLEMENTO',
  FUNILARIA = 'FUNILARIA',
  PREPARACAO = 'PREPARACAO',
  PINTURA = 'PINTURA',
  MECANICA = 'MECANICA',
  MONTAGEM = 'MONTAGEM',
  POLIMENTO = 'POLIMENTO',
  LAVAGEM = 'LAVAGEM',
  ACABAMENTO = 'ACABAMENTO',
  CONTROLE_QUALIDADE = 'CONTROLE_QUALIDADE',
  VISTORIA_SEGURADORA = 'VISTORIA_SEGURADORA',
  FINALIZADO = 'FINALIZADO',
}

export interface Orcamento {
  id: number;
  placa: string;
  marca: string;
  modelo: string;
  valor: number;
  consultorResponsavel: string;
  status: OrcamentoStatus;
  clienteNome: string;
  clienteTelefone: string;
  clienteEmail: string;
  criadoEm: Date;
  valorOrcamento?: number;
  consultor?: string;
  statusLead?: LeadStatus;
  statusAtendimento?: OrcamentoAtendimentoStatus;
  dataCriacao?: Date;
  dataFechamento?: Date | null;
  virouOs?: boolean;
  codigoExterno?: string;
  seguradoraNome?: string;
  sinistroNumero?: string;
  fase?: OrcamentoFase;
  ultimoContatoEm?: Date | null;
  proximoContatoEm?: Date | null;
  motivoPerda?: string | null;
  dataPrevistaEntrega?: Date | null;
  responsavelAtual?: string;
  prioridade?: AtendimentoPrioridade;
}

export interface LeadContatoPlanejado {
  id: number;
  orcamentoId: number;
  dataHora: Date;
  canal: LeadCanal;
  assunto: string;
  observacao?: string;
  concluido: boolean;
}

export interface Workflow {
  id: number;
  osNumero: string;
  placa: string;
  marca: string;
  modelo: string;
  clienteNome: string;
  responsavelAtual: string;
  etapaAtual: WorkflowEtapaTipo;
  statusGeral: WorkflowStatus;
  criadoEm: Date;
  clienteTelefone?: string;
  clienteEmail?: string;
  seguradoraNome?: string;
  sinistroNumero?: string;
  consultorResponsavel?: string;
  fase?: WorkflowFase;
  ultimoContatoEm?: Date | null;
  proximoContatoEm?: Date | null;
  dataPrevistaEntrega?: Date | null;
  diasNaEtapaAtual?: number;
  atrasoDias?: number;
}

export interface WorkflowEtapa {
  tipo: WorkflowEtapaTipo;
  nome: string;
  inicio?: Date;
  fim?: Date;
  previstaInicio?: Date;
  previstaFim?: Date;
  checklist: ChecklistItem[];
  observacoes: string[];
  anexos: Anexo[];
  responsavel: string;
  concluido: boolean;
}

export interface ChecklistItem {
  id: number;
  texto: string;
  ok: boolean;
}

export interface Anexo {
  id: number;
  nomeArquivo: string;
  etapa: WorkflowEtapaTipo;
  anexadoPor: string;
  dataHora: Date;
}

export interface ComunicacaoCliente {
  id: number;
  workflowId: number;
  canal: ComunicacaoCanal;
  para: string;
  mensagem: string;
  dataHora: Date;
  statusEnvio: ComunicacaoStatusEnvio;
}

export interface HistoricoInteracao {
  id: number;
  workflowId: number;
  dataHora: Date;
  tipo: HistoricoTipo;
  descricao: string;
  usuario: string;
}

export interface WorkflowDetalhe extends Workflow {
  etapas: WorkflowEtapa[];
  historico: HistoricoInteracao[];
  comunicacoes: ComunicacaoCliente[];
}
